import styled from "styled-components";

const ProfilGameLayout = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export default ProfilGameLayout;
